<script lang="ts">
  import {onDestroy} from 'svelte';
  import editorStore from '../editor.store';
  export let targetAttribute: keyof CSSStyleDeclaration; // Can be either color / background color / border color;
  let value: string = '';
  const onChange = () => {
    $editorStore.activeComponent.style[targetAttribute] = value;
  };
  const unsubscribe = editorStore.subscribe(store => {
    value = store.activeComponent.style[targetAttribute];
  });

  onDestroy(() => unsubscribe);
</script>

Change Color
<input type="color" bind:value on:change={onChange} />
